import Collection from '@/components/Collection'
import access from '../access'

export default {

  'request_log.collection':{
    path: '/admin/request-logs',
    name: 'request_log.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listRequestLogs",
      entity: "request_log",
      cols: [
        {label: "Correlation", sort: "correlation", uuid: "correlation"},
        {label: "Namespace", field: "namespace"},
        {label: "Method", field: "method"},
        {label: "User", uuid: "user"}, // TODO: link to user?
        {label: "IP", field: "ip_address", sort: "ip"},
        {label: "Time", field: "timestamp", timestamp: "default", sort: "timestamp"},
      ]
    },
    meta: {
      access: access.admin,
      title: "Request logs",
      side_menu: { label: "Request Logs",  icon: "connection", weight: 100 },
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/request-log.js